import request from "../request";

export default {
  // 列表
  lists(data) {
    return request.get("/category/lists", data);
  },

  //添加
  add(data) {
    return request.post("/category/add", data);
  },

  // 编辑
  edit(data) {
    return request.post("/category/edit", data);
  },

  // 删除
  delete(data) {
    return request.post("/category/delete", data);
  },

};
